import PhoneNumber from 'awesome-phonenumber';

export const formatPhone = p => {
    let phone = p.replace(/^00/, '+');
    let pn = new PhoneNumber(phone, 'CZ');

    if (!pn.isValid()) {
        return p;
    }
/*
    if (pn.getRegionCode() === 'CZ') {
        return pn.getNumber('national');
    }
*/
    return pn.getNumber('international');
};

export const countryCodeOptions = [
    {name: 'CZ (+420)', value: '+420'}
];


// WEBPACK FOOTER //
// ./src/helpers/phone.js